<template>
  <div class="autoResult" v-if="autoSearchRender">
    <ul>
      <li
        v-for="(item, k) in autoProducts"
        v-bind:key="k"
        class="section-item"
      >
        <a :href="`${baseUrl}book/${item.id}`" class="d-flex">
          <div>
            <vue-load-image>
              <img
                slot="image"
                v-bind:src="`${IMAGEURL}${item.image}`"
                alt=""
                class="img-responsive"
              />
            </vue-load-image>
          </div>
          <div>
            <h2 v-if="item.product_name.length < 30">
              {{ item.product_name }}
            </h2>
            <h2
              v-if="item.product_name.length >= 30"
              :title="`${item.product_name}`"
            >
              {{ item.product_name.substr(0, 30) + "..." }}
            </h2>

            <div>
              <span
                v-for="(authorRow, index) in item.author"
                v-bind:key="index"
                class="font-12"
              >
                {{ authorRow.author_info.author_name }}
                <span v-if="index + 1 < item.author.length">, </span>
              </span>
            </div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import VueLoadImage from "vue-load-image";
export default {
  name: "AutoSearch",
  props: ["autoSearchRender", "autoProducts"],
  components: {
    VueLoadImage,
  },
};
</script>
